<template>
    <div class="@container/tone">
        <div class="text-slate-700 text-base font-bold">Voice</div>

        <div class="mt-4 grid gap-2 grid-cols-2 @lg/tone:grid-cols-4">
            <vx-radio-selection-item value="friendly" @selected="emit('update:modelValue', $event)" :active="'friendly' === props.modelValue">
                Friendly
            </vx-radio-selection-item>
            <vx-radio-selection-item value="formal" @selected="emit('update:modelValue', $event)" :active="'formal' === props.modelValue">
                Formal
            </vx-radio-selection-item>
            <vx-radio-selection-item value="casual" @selected="emit('update:modelValue', $event)" :active="'casual' === props.modelValue">
                Casual
            </vx-radio-selection-item>
            <vx-radio-selection-item value="funny" @selected="emit('update:modelValue', $event)" :active="'funny' === props.modelValue">
                Funny
            </vx-radio-selection-item>
        </div>
        <div v-if="props.error" class="mt-1 px-0.5 text-xs text-rose-800">{{ props.error }}</div>
    </div>
</template>

<script setup>
import { VxRadioSelectionItem } from '@voxie/frontend-components';

const props = defineProps({
    modelValue: {
        type: String,
    },
    error: {
        type: String,
        default: undefined,
    },
})

const emit = defineEmits(['update:modelValue']);
</script>
